/**
 * 晓鲸电波
 */
import BaseContext from '../basecontext/index.js';
import FootDectorator from '../dectorator/footdectorator/index.js';
import {checkFootAuth, checkFootTitleAuth} from '../dectorator/checkauthdectorator/index.js';
import Util, {mergeModelData, curryFun} from '../../util/index.js';
import {
  transformTime,
  checkAmerican
} from '../../controller/util.js';
const model = {
  signals: {
    Type: Array,
    Default: () => ([]),
  },
};
export default class KLineElectricState extends FootDectorator(BaseContext) {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
    const {signals, min_time, code} = this.state.data;
    const isAmerican = checkAmerican(code);
    const time = min_time.map(a => transformTime({timeStamp: a, code, isAmerican}));
    signals.forEach(item => {
      item.index = time.findIndex(a => a === item['change_date']);
      // item.index = min_time.findIndex(a => a === item['change_date']);
    });
  }
  // @checkFootAuth({
  //   image: image,
  //   key: 'XJDB'
  // })
  _drawMain() {
    const ctx = this.context;
    const {barWidth, barSpace, height, top, left, bottom, right} = this.availArea;
    const {signals, start, end} = this.state.data;
    const signalsList = signals.filter(a => a.index >= start && a.index < end);
    const {
      colorMap
    } = this.option.BaseContext;
    const {
      width,
      color,
      lineWidth,
    } = this.option.XJDB;
    const middleY = height / 2 + top;
    this._drawSolid({x: left, y: middleY}, {x: right, y: middleY}, lineWidth, color);
    if (Util.isValidArray(signalsList)) {
      signalsList.forEach(signal => {
        const isRise = !!signal['xjdbxh_b'];
        const color = isRise ? colorMap[1] : colorMap[0];
        const topY = isRise ? top : bottom;
        ctx.beginPath();
        ctx.fillStyle = color;
        const leftX = left + barWidth / 2 + (signal['index'] - start) * (barSpace + barWidth);
        ctx.moveTo(leftX - width / 2, middleY);
        ctx.lineTo(leftX, topY);
        ctx.lineTo(leftX + width / 2, middleY);
        ctx.closePath();
        ctx.fill();
      });
    }
  }
  _drawAxisY() {
    const ctx = this.context;
    const {barWidth, barSpace, height, top, left, bottom, right} = this.availArea;
    const {
      sizeRatio,
      fontFamily,
      color,
      lineWidth,
      text,
    } = this.option.XJDB;
    ctx.beginPath();
    ctx.font = sizeRatio * this.state.baseSize * this.dpr + "px " + fontFamily;
    ctx.fillStyle = color;
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.fillText(text, left, top);
  }
  // @checkFootTitleAuth
  _drawTitle() {
    super._drawTitle();
  }
}
